import gql from "graphql-tag";

export const GET_VENDORS = gql`
    query (
        $client: uuid
        $limit_value: Int
        $offset_value: Int
        $vendors: String
    ) {
        spendmd_db_ap_vendors(
            args: {
                limit_value: $limit_value
                offset_value: $offset_value
                client: $client
                vendors: $vendors
            }
        ) {
            id
            non_po_spend
            total_categories
            vendor_name
            po_spend
        }
        spendmd_db_ap_vendors_aggregate(
            args: {
                limit_value: null
                offset_value: null
                client: $client
                vendors: $vendors
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;

export const MAPPED_VENDOR = gql`
    query ($vendor_identifier: Int!, $limit: Int!, $offset: Int!) {
        spendmd_db_get_vendor_name(
            args: { vendor_identifier: $vendor_identifier }
        ) {
            client_id
            client_name
            vendor_id
            vendor_name
        }
        spendmd_db_get_mapped_data(
            args: { vendor_identifier: $vendor_identifier }
            limit: $limit
            offset: $offset
        ) {
            id
            item_description
            prime_category_id
            prime_category_name
            secondary_category_id
            secondary_category_name
            sub_category_id
            sub_category_name
            total_spend
            vendor_catalog
        }
        spendmd_db_get_mapped_data_aggregate(
            args: { vendor_identifier: $vendor_identifier }
        ) {
            aggregate {
                count
            }
        }
    }
`;

export const UpmappedAP = gql`
    query ($vendor_identifier: Int!) {
        spendmd_db_get_vendor_name(
            args: { vendor_identifier: $vendor_identifier }
        ) {
            client_id
            client_name
            vendor_id
            vendor_name
        }
        spendmd_db_ap_unmapped_aggregate(
            args: { vendor_identifier: $vendor_identifier }
        ) {
            nodes {
                id
                prime_category_id
                prime_category_name
                secondary_category_id
                secondary_category_name
                sub_category_id
                sub_category_name
                total_spend
            }
            aggregate {
                sum {
                    total_spend
                }
            }
        }
    }
`;

export const UNMAPPED_PO = gql`
    query ($vendor_identifier: Int!) {
        spendmd_db_get_vendor_name(
            args: { vendor_identifier: $vendor_identifier }
        ) {
            client_id
            client_name
            vendor_id
            vendor_name
        }
        spendmd_db_po_unmapped_aggregate(
            args: { vendor_identifier: $vendor_identifier }
        ) {
            nodes {
                id
                prime_category_id
                prime_category_name
                secondary_category_id
                secondary_category_name
                sub_category_id
                sub_category_name
                total_spend
            }
            aggregate {
                sum {
                    total_spend
                }
            }
        }
    }
`;

export const INSERT_AP_CATEGORIES = gql`
    mutation InsertCategories(
        $categories: jsonb
        $client: String
        $vendor_id: Int
    ) {
        spendmd_db_insert_categories_test(
            args: {
                categories: $categories
                client: $client
                vendor: $vendor_id
            }
        ) {
            id
            vendor_id
            primary_id
            primary_name
            secondary_id
            secondary_name
            sub_id
            sub_name
            allocation_percent
            client_id
        }
    }
`;

export const INSERT_PO_CATEGORIES = gql`
    mutation InsertPOCategories(
        $categories: jsonb
        $client: String
        $vendor_id: Int
    ) {
        spendmd_db_insert_po_categories(
            args: {
                categories: $categories
                client: $client
                vendor: $vendor_id
            }
        ) {
            id
            vendor_id
            primary_id
            primary_name
            secondary_id
            secondary_name
            sub_id
            sub_name
            allocation_percent
            client_id
        }
    }
`;

export const GET_PRIME_CATEGORIES = gql`
    query {
        spendmd_db_prime_categories(distinct_on: id) {
            id
            name
        }
    }
`;

export const GET_SECONDARY_CATEGORIES = gql`
    query ($primary_category_id: Int!) {
        spendmd_db_secondary_categories(
            distinct_on: id

            where: { prime_category_id: { _eq: $primary_category_id } }
        ) {
            id

            name
        }
    }
`;

export const GET_SUB_CATEGORIES = gql`
    query ($secondary_category_id: Int!) {
        spendmd_db_sub_categories(
            distinct_on: id

            where: { secondary_category_id: { _eq: $secondary_category_id } }
        ) {
            id

            name
        }
    }
`;

export const SEARCH_VENDORS = gql`
    query ($limit: Int!, $offset: Int!, $searchVal: String!, $client_id: uuid) {
        spendmd_db_vendor_master(
            limit: $limit
            offset: $offset
            order_by: { vendor_name: asc }
            where: {
                vendor_name: { _ilike: $searchVal }
                client_id: { _eq: $client_id }
            }
        ) {
            id
        }
    }
`;

export const SET_VENDORS = gql`
    mutation (
        $address: String
        $keywords: jsonb!
        $city: String
        $normal_name: String!
        $zip_code: String
        $state: String
        $vendor_name: String!
        $website: String
        $client_id: uuid!
    ) {
        insert_spendmd_db_vendor_master(
            objects: {
                address: $address
                keywords: $keywords
                city: $city
                normal_name: $normal_name
                zip_code: $zip_code
                state: $state
                vendor_name: $vendor_name
                website: $website
                client_id: $client_id
            }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_VENDORS = gql`
    mutation (
        $address: String
        $keywords: jsonb!
        $city: String
        $normal_name: String!
        $zip_code: String
        $state: String
        $vendor_name: String!
        $website: String
        $id: Int!
        $client_id: uuid!
    ) {
        update_spendmd_db_vendor_master(
            _set: {
                address: $address
                keywords: $keywords
                city: $city
                normal_name: $normal_name
                zip_code: $zip_code
                state: $state
                vendor_name: $vendor_name
                website: $website
                client_id: $client_id
            }
            where: { id: { _eq: $id } }
        ) {
            returning {
                id
            }
        }
    }
`;

export const DELETE_VENDORS = gql`
    mutation ($id: Int!) {
        delete_spendmd_db_vendor_category_allocation(
            where: { vendor_id: { _eq: $id } }
        ) {
            returning {
                id
            }
        }
        delete_spendmd_db_vendor_master(where: { id: { _eq: $id } }) {
            returning {
                id
            }
        }
    }
`;

export const SET_VENDOR_CATEGORY_ALLOCATIONS = gql`
    mutation (
        $prime_category: Int!
        $category: Int
        $sub_category: Int
        $vendor_id: Int!
        $allocation: Int!
        $client_id: uuid!
    ) {
        insert_spendmd_db_vendor_category_allocation(
            objects: {
                prime_category: $prime_category
                secondary_category: $category
                sub_category: $sub_category
                vendor_id: $vendor_id
                allocation: $allocation
                client_id: $client_id
            }
        ) {
            returning {
                id
            }
        }
    }
`;

export const UPDATE_VENDOR_CATEGORY_ALLOCATIONS = gql`
    mutation (
        $prime_category: Int!
        $category: Int
        $sub_category: Int
        $allocation: Int!
        $id: Int!
    ) {
        update_spendmd_db_vendor_category_allocation(
            _set: {
                allocation: $allocation
                prime_category: $prime_category
                secondary_category: $category
                sub_category: $sub_category
            }
            where: { id: { _eq: $id } }
        ) {
            returning {
                id
            }
        }
    }
`;

export const DELETE_VENDOR_CATEGORY_ALLOCATIONS = gql`
    mutation ($id: Int!) {
        delete_spendmd_db_vendor_category_allocation(
            where: { id: { _eq: $id } }
        ) {
            returning {
                id
            }
        }
    }
`;

export const GET_VENDOR_KEYWORD = gql`
    query MyQuery {
        spendmd_db_keyword_master {
            keywords
            id
        }
    }
`;
export const SET_VENDOR_KEYWORD = gql`
    mutation ($keywords: String!) {
        insert_spendmd_db_keyword_master(objects: { keywords: $keywords }) {
            returning {
                id
            }
        }
    }
`;

export const APPROVE_SPENDS_ON_VENDOR = gql`
    mutation ($vendor_name: String!, $client_id: uuid!) {
        update_spendmd_db_spend_data(
            _set: { is_approved: true }
            where: {
                remit_to_name: { _eq: $vendor_name }
                client_id: { _eq: $client_id }
            }
        ) {
            returning {
                id
                doc_date
                net_amount
            }
        }
    }
`;

export const INSERT_SPEND_DATA_FINAL = gql`
    mutation (
        $client_id: uuid!
        $doc_date: date!
        $net_amount: money!
        # $prime_category_id: Int!
        # $prime_category_name: String!
        # $secondary_category_id: Int!
        # $secondary_category_name: String!
        # $sub_category_id: Int!
        # $sub_category_name: String!
        $vendor_id: Int!
        $vendor_name: String!
        $spend_id: Int!
    ) {
        insert_spendmd_db_spend_data_final(
            objects: {
                client_id: $client_id
                doc_date: $doc_date
                net_amount: $net_amount
                # prime_category_id: $prime_category_id
                # prime_category_name: $prime_category_name
                # secondary_category_id: $secondary_category_id
                # secondary_category_name: $secondary_category_name
                spend_id: $spend_id
                # sub_category_id: $sub_category_id
                # sub_category_name: $sub_category_name
                vendor_id: $vendor_id
                vendor_name: $vendor_name
            }
        ) {
            returning {
                id
            }
        }
    }
`;
